import { render, staticRenderFns } from "./DesigningTasks.vue?vue&type=template&id=0e84a194&"
import script from "./DesigningTasks.vue?vue&type=script&lang=ts&"
export * from "./DesigningTasks.vue?vue&type=script&lang=ts&"
import style0 from "./DesigningTasks.vue?vue&type=style&index=0&id=0e84a194&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports